var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuContactUsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6.61111C12.7459 6.61111 13.1416 6.775 13.4333 7.06672C13.725 7.35845 13.8889 7.75411 13.8889 8.16667M12.3333 3.5C13.571 3.5 14.758 3.99167 15.6332 4.86684C16.5083 5.742 17 6.92899 17 8.16667M4.55556 4.27778H7.66667L9.22222 8.16667L7.27778 9.33333C8.11075 11.0223 9.4777 12.3893 11.1667 13.2222L12.3333 11.2778L16.2222 12.8333V15.9444C16.2222 16.357 16.0583 16.7527 15.7666 17.0444C15.4749 17.3361 15.0792 17.5 14.6667 17.5C11.6328 17.3156 8.77123 16.0273 6.62198 13.878C4.47273 11.7288 3.18437 8.86724 3 5.83333C3 5.42077 3.16389 5.02511 3.45561 4.73339C3.74733 4.44167 4.143 4.27778 4.55556 4.27778Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuContactUsIcon);
export default __webpack_public_path__ + "static/media/menu-contact-us-icon.73bb5106a9f05b9c779d1468165945c4.svg";
export { ForwardRef as ReactComponent };